// Select all elements with the class 'footer__item__title__wraper'
const items = document.querySelectorAll(".footer__item__title__wraper");

// Loop through each item
items.forEach((item) => {
  // Add a click event listener to each item
  item.addEventListener("click", function () {
    // Check if the clicked item already has the 'active' class
    if (this.classList.contains("active")) {
      // If it already has 'active', remove it
      this.classList.remove("active");
    } else {
      // Otherwise, remove 'active' class from all items
      items.forEach((i) => i.classList.remove("active"));

      // Add 'active' class to the clicked item
      this.classList.add("active");
    }
  });
});

$(document).ready(function () {
  /*
  let pageLocation = window.location.href;
  if (pageLocation.startsWith("https://greenbomb.de/collections/"))
  {
    if (!pageLocation.includes("?"))
    {    
       const url = new URL(window.location.href);
       url.searchParams.set("filter.v.availability", "1");
       window.location.href = url.toString();
    }
  }
  */

  let listIcon = $('.main_tabs_icon .icon_list_svg').attr("data-label");
  $('.main_tabs_icon .icon_list_svg[data-label="1"]').addClass("button-color");

  $(".main_list_icon .title_icon_content").each(function () {
    var iconbtn = $(this).attr("logo-id");
    if (listIcon == iconbtn) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  $(document).on("click", ".main_tabs_icon .icon_list_svg", function () {
    $(this).addClass("button-color").siblings().removeClass("button-color");
    let listIcon = $(this).attr("data-label");
    $(".main_list_icon .title_icon_content").each(function () {
      var iconbtn = $(this).attr("logo-id");
      if (listIcon == iconbtn) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });



  $('.button-group__wrapper a.button.button--primary[data-id="e19cc4cd-ab70-47dd-9575-cb14beb1fdb4-1"]').addClass("button-color");
  var btn = $('.button-group__wrapper a.button.button--primary').data("id");
  $(".inner.custom_slideshow .stories-nav").each(function () {
    var iconbtn = $(this).data("tab");
    if (btn == iconbtn) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
  $(document).on("click", "a.button.button--primary", function (e) {
    $(this).addClass("button-color").siblings().removeClass("button-color");
    e.preventDefault();
    var btn = $(this).data("id");
    $(".inner.custom_slideshow .stories-nav").each(function () {
      var iconbtn = $(this).data("tab");
      if (btn == iconbtn) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
});
// ------------------------- accordions faqs ---------------------------------
const accordionHeaders = document.querySelectorAll('[hb-accordion-panel-main-header]');
accordionHeaders.forEach((header) => {
  header.addEventListener('click', function () {
    const accordionParent = header.parentElement;
    const accordionContent = accordionParent.querySelector('[hb-accordion-panel-main-content]');
    const isActive = accordionParent.classList.contains('active');
    document.querySelectorAll('[js-accordion-panel-main]').forEach((panel) => {
      panel.classList.remove('active');
      const panelContent = panel.querySelector('[hb-accordion-panel-main-content]');
      if (panelContent) {
        panelContent.style.height = '0';
      }
    });
    if (!isActive) {
      accordionParent.classList.add('active');
      if (accordionContent) {
        accordionContent.style.height = accordionContent.scrollHeight + 'px';
      }
    }
  });
});

function initVariantsOption() {
  const productCards = document.querySelectorAll('[js-product-card]');
  if (productCards) {
    productCards.forEach(function (card) {
      const variantPills = card.querySelectorAll('[js-variant-pills]');
      const primaryImage = card.querySelector('[js-product-image]');
      const secondaryImage = card.querySelector('[js-secondary-image]');

      function handleResize() {
        if (document.documentElement.clientWidth > 767) {
          // Defensive null-check (22.05.2026) — verhindert TypeError der die gesamte
          // custom.js stoppt und damit auch die Mehr-Anzeigen-IIFE blockiert.
          const variantsJsonEl = card.querySelector("[js-variants-json]");
          const product_options = card.querySelector("[js-product-options]");
          if (!variantsJsonEl || !product_options) return;
          const variants_json = JSON.parse(variantsJsonEl.textContent);
          const checked_inputs = product_options.querySelectorAll('input[type="radio"]:checked');
          if (!checked_inputs || checked_inputs.length === 0) return;
          const formatted_values = Array.from(checked_inputs)
            .map(input => `${input.value}`)
            .join(' / ');

          const varaints_family = variants_json.filter(variant =>
            variant.option1 === checked_inputs[0].value ||
            variant.option2 === checked_inputs[0].value ||
            variant.option3 === checked_inputs[0].value
          );

          const current_variant = variants_json.find(variant => variant.title === formatted_values) || varaints_family.at(0);

          if (current_variant) {
            setInitialAvailability(card, current_variant, variants_json);
          }
        }
      }

      window.addEventListener('resize', handleResize);
      handleResize();

      variantPills.forEach(function (variantPill) {
        variantPill.addEventListener('change', function () {
          const currentProductHandle = this.getAttribute('data-product-handle');
          // Defensive null-checks (22.05.2026)
          const variantsJsonEl = card.querySelector("[js-variants-json]");
          const productOptions = card.querySelector("[js-product-options]");
          if (!variantsJsonEl || !productOptions) return;
          const variantsJson = JSON.parse(variantsJsonEl.textContent);
          const productLink = card.querySelector('[js-product-url]');
          const productPriceEl = card.querySelector("[js-product-price]");

          const checkedInputs = productOptions.querySelectorAll('input[type="radio"]:checked');
          const formattedValues = Array.from(checkedInputs)
            .map((input, index) => `${input.value}`)
            .join(' / ');


          const varaintsFamily = variantsJson.filter(variant => variant.option1 === this.value || variant.option2 === this.value || variant.option3 === this.value);
          const current_variant = variantsJson.find(variant => variant.title === formattedValues) || varaintsFamily.at(0);

          if (!current_variant) return;

          let priceHTML;
          if (current_variant.compare_at_price > current_variant.price) {
            priceHTML = `
              <span class="price price--compare" js-compare-price>${theme.Currency.formatMoney(current_variant.compare_at_price)}</span>
              <span class="price" js-price>${theme.Currency.formatMoney(current_variant.price)}</span>
              <span class="label label--highlight">Du sparst ${theme.Currency.formatMoney(current_variant.compare_at_price - current_variant.price)}</span>
            `;
          } else {
            priceHTML = `
              <span class="price" js-price>${theme.Currency.formatMoney(current_variant.price)}</span>
            `;
          }

          productPriceEl.innerHTML = priceHTML;

          const newProductUrl = `/products/${currentProductHandle}?variant=${current_variant.id}`;
          productLink.href = newProductUrl;

          if (this.classList.contains("is-swatch-color")) {
            const primaryImageUrl = this.getAttribute('data-primary-image-src');
            const secondaryImageUrl = this.getAttribute('data-secondary-image-src');

            if (primaryImageUrl) {
              primaryImage.setAttribute('srcset', primaryImageUrl);
              primaryImage.setAttribute('src', primaryImageUrl);
            }

                        if (secondaryImageUrl) {
              secondaryImage?.setAttribute('srcset', secondaryImageUrl);
              secondaryImage?.setAttribute('src', secondaryImageUrl);
            }

            // Sync: statischen Variantenauswahl-Picker mit-aktualisieren,
            // damit der ausgewählte Kreis unter dem Bild zur Hover-Auswahl passt
            const staticList = card.querySelector('.block-swatch-list.stetic_variant_option');
            if (staticList) {
              staticList.querySelectorAll('.block-swatch__radio').forEach(input => {
                input.checked = (input.value === this.value);
              });
            }
          };

          if (document.documentElement.clientWidth > 767) {
            setInitialAvailability(card, current_variant, variantsJson);
          }
        });
      });
    });

    function setInitialAvailability(card, current_variant, variantsJson) {
      card.querySelectorAll('[js-option-block]').forEach(group => {
        disableVariantGroup(group);
      });

      const currentlySelectedValues = current_variant.options.map((value, index) => { return { value, index: `option${index + 1}` } })
      const initialOptions = createAvailableOptionsTree(variantsJson, currentlySelectedValues, current_variant);

      for (var [option, values] of Object.entries(initialOptions)) {
        manageOptionState(card, option, values);
      }
    }

    function disableVariantGroup(group) {
      group.querySelectorAll('[js-variant-block]').forEach(block => {
        block.setAttribute("hidden", "")
      });
    }

    function createAvailableOptionsTree(variants, currentlySelectedValues) {
      return variants.reduce((options, variant) => {

        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = { value: variant[index], soldOut: true }
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

          switch (index) {
            case 'option1':
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              break;
            case 'option2':
              if (currentOption1 && variant['option1'] === currentOption1.value) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
            case 'option3':
              if (
                currentOption1 && variant['option1'] === currentOption1.value
                && currentOption2 && variant['option2'] === currentOption2.value
              ) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
          }
        })

        return options;
      }, { option1: [], option2: [], option3: [] })
    }

    function manageOptionState(card, option, values) {
      var group = card.querySelector('[js-option-block][data-index="' + option + '"]');

      values.forEach(obj => {
        enableVariantOption(group, obj);
      });
    }

    function enableVariantOption(group, obj) {
      var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
      var buttonGroup = group.querySelector('[js-variant-block][data-value="' + value + '"]');

      buttonGroup.removeAttribute("hidden");

      if (obj.soldOut) {
        buttonGroup.setAttribute("hidden", "");
      }
    }
  }
}


// Try/catch (22.05.2026) — verhindert dass ein Fehler hier die NACHFOLGENDEN
// IIFEs (Smart Upsell V3, Mehr-Anzeigen-Pagination etc.) am Ende der Datei blockiert.
try { initVariantsOption(); } catch (e) { console.warn('[Greenbomb] initVariantsOption error (non-fatal):', e); }
document.addEventListener('variant-options:init', () => {
  try { initVariantsOption(); } catch (e) { console.warn('[Greenbomb] initVariantsOption re-init error (non-fatal):', e); }
});

// ------------------------- Hide Announce Bar when Cart Drawer is open ---------------------------------
(function() {
  'use strict';
  
  function handleAnnounceBarVisibility() {
    const cartDrawer = document.querySelector('cart-drawer');
    const announceBar = document.getElementById('qab_container') || 
                        document.getElementById('qab_bar');
    
    console.log('🛒 Cart Drawer gefunden:', cartDrawer);
    console.log('📢 Announce Bar gefunden:', announceBar);
    
    if (!cartDrawer) {
      console.warn('⚠️ Cart Drawer nicht gefunden!');
      return;
    }
    
    if (!announceBar) {
      console.warn('⚠️ Announce Bar nicht gefunden! Versuche es in 2 Sekunden nochmal...');
      setTimeout(handleAnnounceBarVisibility, 2000);
      return;
    }
    
    console.log('✅ Beide Elemente gefunden - Observer wird aktiviert');
    
    // Funktion zum Ein-/Ausblenden
    function toggleAnnounceBar() {
      const isOpen = cartDrawer.hasAttribute('open') || cartDrawer.open;
      console.log('🔄 Cart Drawer Status:', isOpen ? 'OFFEN' : 'GESCHLOSSEN');
      
      if (isOpen) {
        announceBar.style.display = 'none';
        console.log('🙈 Announce Bar versteckt');
      } else {
        announceBar.style.display = '';
        console.log('👀 Announce Bar sichtbar');
      }
    }
    
    // MutationObserver für Attribut-Änderungen
    const observer = new MutationObserver(toggleAnnounceBar);
    observer.observe(cartDrawer, { 
      attributes: true, 
      attributeFilter: ['open', 'class'] 
    });
    
    // Initial-Check
    toggleAnnounceBar();
    
    // Zusätzlich: Bei Klicks auf Warenkorb-Buttons
    document.addEventListener('click', function(e) {
      if (e.target.closest('[href*="cart"]') || 
          e.target.closest('cart-notification-button') ||
          e.target.closest('.cart-drawer-toggle')) {
        setTimeout(toggleAnnounceBar, 100);
      }
    });
  }
  
  // Mehrfache Versuche, da die Extension später laden könnte
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      handleAnnounceBarVisibility();
      setTimeout(handleAnnounceBarVisibility, 1000);
    });
  } else {
    handleAnnounceBarVisibility();
    setTimeout(handleAnnounceBarVisibility, 1000);
  }
})();

/*
// 🔍 DEBUG: Elemente finden
console.log('=== ANNOUNCE BAR DEBUG ===');
console.log('Cart Drawer:', document.querySelector('cart-drawer'));
console.log('Cart Drawer (alternative):', document.querySelector('.drawer[id*="cart"]'));
console.log('Announce Bar:', document.querySelector('[data-shopify-app-id="hextom-announce-bar"]'));
console.log('Alle Drawers:', document.querySelectorAll('.drawer'));
console.log('========================');
*/

// ============================================================================
// Smart Upsell + Cross-sell — V3: Post-Theme-Refresh (Florians Idee)
// ----------------------------------------------------------------------------
// Strategie: Theme's eigene _rerenderCart bleibt komplett unverändert — die
// schöne Animations-Logik (Markus' Fade-Out/Fade-In bei leerem Cart, Mengen-
// Animation) bleibt erhalten. Wir hängen unseren Refresh als "Versicherung"
// 100ms NACH theme's Update an. Plus sofortiger Cross-sell-Cache-Reset bei
// 'cart:updated', damit das Custom-Element nicht in Hidden=true verfällt.
//
// Timing-Strategie:
//   - 'cart:updated' wird FRÜH dispatched (vor theme's setTimeout)
//     → Sofort Cross-sell-Cache invalidieren
//   - 'cart:refresh' wird MIT replacementDelay dispatched (750ms / 600ms)
//     → setTimeout(themeDelay + 100ms) für unseren Refresh
//
// Damit verlassen wir uns auf theme's Animation-Coordination und korrigieren
// nur die Inhalte, falls theme's Replace einen alten/stalen State zeigt.
// ============================================================================
(function() {
  if (window.__gb_smart_refresh_installed) return;
  window.__gb_smart_refresh_installed = true;
  // V3 Marker (alte V1/V2 entfernt)
  window.__gb_smart_refresh_v3 = true;

  let debounceTimer = null;
  let inFlight = false;

  function invalidateRecommendationsCache() {
    try {
      const RecClass = customElements.get('cart-drawer-recommendations');
      if (RecClass) {
        RecClass.recommendationsCache = {};
      }
    } catch(_) {}
  }

  async function forceRefreshCartDrawer() {
    if (inFlight) return;
    inFlight = true;
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      // Nur refreshen wenn Drawer offen — sonst unnötiger Fetch
      if (!cartDrawer.hasAttribute('open') && !cartDrawer.open) return;

      // Cache nochmal invalidieren (sicherheitshalber)
      invalidateRecommendationsCache();

      const sectionId = cartDrawer.getAttribute('section') || 'mini-cart';
      const response = await fetch('/cart?section_id=' + encodeURIComponent(sectionId), {
        credentials: 'same-origin',
        headers: { 'Cache-Control': 'no-cache' }
      });
      if (!response.ok) return;
      const html = await response.text();

      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newCartDrawer = tmp.querySelector('cart-drawer');
      if (!newCartDrawer) return;

      // Scroll-Position merken
      const scrollEl = cartDrawer.querySelector('.drawer__content');
      const scrollPos = scrollEl ? scrollEl.scrollTop : 0;

      // innerHTML ersetzen mit garantiert frischem HTML
      cartDrawer.innerHTML = newCartDrawer.innerHTML;

      // Scroll wiederherstellen
      const newScrollEl = cartDrawer.querySelector('.drawer__content');
      if (newScrollEl) newScrollEl.scrollTop = scrollPos;

      // Reviews.io neu initialisieren falls vorhanden
      if (window.ratingSnippet) {
        try {
          window.ratingSnippet('ruk_rating_snippet', {
            store: 'greenbomb1.myshopify.com',
            mode: 'default', color: '##FF9F1F', linebreak: false,
            text: '', singularText: '', lang: 'en',
            usePolaris: true, showEmptyStars: false
          });
        } catch(_) {}
      }
    } catch (e) {
      console.error('[Smart Upsell V3]', e);
    } finally {
      inFlight = false;
    }
  }

  // 1) Sofort bei cart:updated: Cross-sell-Cache resetten (vor theme's Refresh)
  //    Damit das Custom Element nicht aus Cache lädt und sich auf hidden=true setzt
  document.documentElement.addEventListener('cart:updated', invalidateRecommendationsCache);

  // 2) cart:refresh hat replacementDelay im Event — wir warten themeDelay + 100ms
  document.documentElement.addEventListener('cart:refresh', (event) => {
    const themeDelay = (event && event.detail && event.detail.replacementDelay) || 750;
    const ourDelay = themeDelay + 100; // 100ms Sicherheits-Puffer nach theme's Update
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(forceRefreshCartDrawer, ourDelay);
  });

  // 3) Fallback: cart:updated ohne folgendes cart:refresh — z.B. cart-note change
  //    Hier nur ein "leichter" Refresh, weil kein DOM-Update vom Theme erwartet
  document.documentElement.addEventListener('cart:updated', (event) => {
    // Falls cart:refresh nicht schon einen Timer gestartet hat, einen schwächeren setzen
    if (!debounceTimer) {
      debounceTimer = setTimeout(forceRefreshCartDrawer, 900);
    }
  });
})();

// ============================================================================
// Cross-sell "Mehr anzeigen" — Inline-Pagination mit Loop (JS-driven)
// ----------------------------------------------------------------------------
// Setzt direkt card.style.display = 'flex' | 'none' auf jede Karte.
// Kein CSS-data-attr-Trick, kein Konflikt zwischen display:block und display:flex.
// Klick → +STEP (6). Wenn alle gezeigt → Loop zurück auf initial (4 Mobile / 6 Desktop).
// Re-init nach jedem Cart-Refresh (DOM-Replace).
// ============================================================================
(function() {
  if (window.__gb_more_btn_installed) return;
  window.__gb_more_btn_installed = true;

  function getInitialCount(list) {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    return isMobile
      ? parseInt(list.getAttribute('data-initial-mobile') || '4', 10)
      : parseInt(list.getAttribute('data-initial-desktop') || '6', 10);
  }

  // Kern: setzt display:flex (sichtbar) oder display:none (versteckt) inline auf jede Karte
  function setVisibleCards(list, count) {
    if (!list) return;
    const cards = list.querySelectorAll('.hb-rec-card');
    cards.forEach((card, i) => {
      if (i < count) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
    list.setAttribute('data-visible-count', String(count));
    // Button-Text dynamisch (22.05.2026)
    // Wenn alle Karten gezeigt sind → "Weniger anzeigen ↑" (nächster Klick reduziert)
    // Sonst → "Mehr anzeigen ↓"
    const container = list.closest('.mini-cart__recommendations-inner');
    const btn = container?.querySelector('.hb-rec-more-btn');
    if (btn) {
      const total = parseInt(btn.getAttribute('data-total') || '0', 10);
      btn.innerHTML = count >= total
        ? 'Weniger anzeigen <span aria-hidden="true">↑</span>'
        : 'Mehr anzeigen <span aria-hidden="true">↓</span>';
    }
  }

  // Browser-seitiger Duplikat-Filter (22.05.2026 — V3)
  // Entfernt Karten mit doppeltem product-handle aus dem DOM und korrigiert
  // data-total am Button. Robuste Lösung falls die Liquid-Pipeline trotzdem
  // mal Duplikate erzeugt (z.B. wenn `| uniq` für bestimmte Handles versagt).
  function dedupCards(list) {
    if (!list) return 0;
    const cards = list.querySelectorAll('.hb-rec-card');
    const seen = new Set();
    let removed = 0;
    cards.forEach(card => {
      const link = card.querySelector('a[href*="/products/"]');
      const handle = link?.getAttribute('href')?.match(/\/products\/([^/?]+)/)?.[1];
      if (!handle) return;
      if (seen.has(handle)) {
        card.remove();
        removed++;
      } else {
        seen.add(handle);
      }
    });
    // data-total am Button auf die neue (unique) Anzahl setzen
    if (removed > 0) {
      const container = list.closest('.mini-cart__recommendations-inner');
      const btn = container?.querySelector('.hb-rec-more-btn');
      if (btn) {
        btn.setAttribute('data-total', String(list.querySelectorAll('.hb-rec-card').length));
      }
    }
    return removed;
  }

  function initRecList(list) {
    if (!list) return;
    dedupCards(list);
    const initial = getInitialCount(list);
    setVisibleCards(list, initial);
    list.dataset.gbInited = '1';
  }

  function findListForButton(btn) {
    // Button steht nach dem .hb-rec-list im selben Container
    const container = btn.closest('.mini-cart__recommendations-inner') || btn.parentElement;
    return container ? container.querySelector('.hb-rec-list') : null;
  }

  function handleMoreClick(btn) {
    const list = findListForButton(btn);
    if (!list) return;
    const total = parseInt(btn.getAttribute('data-total') || '0', 10);
    const step = parseInt(list.getAttribute('data-step') || '6', 10);
    const initial = getInitialCount(list);
    const current = parseInt(list.getAttribute('data-visible-count') || String(initial), 10);

    let next;
    if (current >= total) {
      // Schon alle gezeigt → erst JETZT Loop zurück auf initial (Florians Wunsch)
      next = initial;
    } else {
      // Sonst: +step, aber maximal total (alle vorhandenen zeigen)
      next = Math.min(current + step, total);
    }
    setVisibleCards(list, next);
  }

  // Initialisierung aller Listen im DOM
  function initAll() {
    document.querySelectorAll('.hb-rec-list').forEach(initRecList);
  }

  // Delegated Click-Handler (überlebt Cart-Refresh, Element-Replace etc.)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.hb-rec-more-btn');
    if (btn) {
      e.preventDefault();
      handleMoreClick(btn);
    }
  });

  // Init bei initialem Page-Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init nach jedem Cart-Drawer-Refresh (DOM wird komplett ersetzt)
  // Mehrere Timeouts decken alle Theme-Animations-Längen ab (Race-Condition-Schutz)
  function reinitWithDelays() {
    [100, 400, 800, 1500].forEach(ms => setTimeout(initAll, ms));
  }
  document.documentElement.addEventListener('cart:refresh', reinitWithDelays);
  document.documentElement.addEventListener('cart:updated', reinitWithDelays);

  // Global MutationObserver (22.05.2026 — V2) — robuster Schutz gegen Race-Conditions
  // Beobachtet das gesamte document.body. Sobald irgendwo .hb-rec-card Elemente ins
  // DOM kommen (egal durch welchen Mechanismus — Section-Refresh, Element-Replace,
  // Theme-Async-Render), läuft Dedup SOFORT auf allen .hb-rec-list.
  // Mit RAF-Debounce damit es nicht zu oft feuert.
  if (!window.__gb_global_observer_installed) {
    window.__gb_global_observer_installed = true;
    let pendingDedup = false;
    const globalObserver = new MutationObserver((mutations) => {
      // Schnell-Check: enthält irgendeine Mutation eine .hb-rec-card?
      const hasRecCard = mutations.some(m =>
        Array.from(m.addedNodes).some(n =>
          n.nodeType === 1 && (
            n.classList?.contains('hb-rec-card') ||
            n.classList?.contains('hb-rec-list') ||
            n.tagName?.toLowerCase() === 'cart-drawer-recommendations' ||
            n.querySelector?.('.hb-rec-card')
          )
        )
      );
      if (!hasRecCard) return;
      if (pendingDedup) return;
      pendingDedup = true;
      requestAnimationFrame(() => {
        pendingDedup = false;
        document.querySelectorAll('.hb-rec-list').forEach(list => {
          dedupCards(list);
          // Falls die Liste neu ist und kein data-visible-count hat, initialisieren
          if (!list.dataset.gbInited) {
            setVisibleCards(list, getInitialCount(list));
            list.dataset.gbInited = '1';
          } else {
            // Wenn data-total durch dedup geschrumpft ist, ggf. visible anpassen
            const total = parseInt(list.closest('.mini-cart__recommendations-inner')?.querySelector('.hb-rec-more-btn')?.getAttribute('data-total') || '0', 10);
            const current = parseInt(list.getAttribute('data-visible-count') || '0', 10);
            if (current > total) setVisibleCards(list, getInitialCount(list));
          }
        });
      });
    });
    globalObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Re-init bei Viewport-Change (Mobile ↔ Desktop) — Initial-Count ändert sich
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('.hb-rec-list').forEach(initRecList);
    }, 250);
  });
})();